<template>
  <div>
    <div class="row">
      <div class="col-md-md">
        <label
          class="text-transform-none"
          style="color: #005d2c; font-size: 18px"
          >{{ dictionary.text_1 }}</label
        >
        <label
          style="color: rgb(147 147 146); font-size: 11px; text-align: justify"
        >
          {{ dictionary.text_2 }}
        </label>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-md-md" style="display: contents">
        <el-radio-group
          @change="changeRadioStation"
          v-model="model.station"
          class="ml-4"
        >
          <el-radio :label="false" class="custom-radio-button"
            >{{ dictionary.label_1 }}
          </el-radio>
          <el-radio :label="true" class="custom-radio-button"
            >{{ dictionary.label_2 }}
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <fg-input
          id="station"
          type="text"
          v-model="model.refStation"
          name="refStation"
          :placeholder="dictionary.placeholder_1"
          :disabled="!model.station"
          maxlength="8"
          @keypress="validateCode"
        ></fg-input>
      </div>
      <div class="col-md-4 py-2" style="display: flex">
        <em
          class="fa fa-exclamation-triangle"
          style="color: #a4a69c; font-size: 18px"
        ></em>
        &nbsp;&nbsp;
        <span style="color: rgb(147 147 146); font-size: 11px"
          >{{ dictionary.text_3 }}
        </span>
      </div>
    </div>
    <div class="row py-2">
      <div class="col" style="display: contents">
        <el-radio-group
          @change="changeRefStationTime"
          v-model="model.refStationTime"
          class="ml-4 custom-radio-button"
        >
          <el-radio :label="false" style="white-space: break-spaces">{{
            dictionary.label_3
          }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col">
        <label
          class="text-transform-none"
          style="color: #005d2c; font-size: 18px"
          >{{ dictionary.text_4 }}</label
        >
      </div>
    </div>
    <div class="row py-2">
      <div class="col" style="display: contents">
        <el-radio-group
          @change="changeRadioSensor"
          v-model="model.sensor"
          class="ml-4"
        >
          <el-radio :label="false" class="custom-radio-button"
            >{{ dictionary.label_1 }}
          </el-radio>
          <el-radio :label="true" class="custom-radio-button"
            >{{ dictionary.label_2 }}
          </el-radio>
        </el-radio-group>
      </div>
      &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
      <div class="col-md" style="">
        <em
          class="fa fa-exclamation-triangle"
          style="color: #a4a69c; font-size: 18px"
        ></em>
        &nbsp;&nbsp;
        <span style="color: rgb(147 147 146); font-size: 11px"
          >{{ dictionary.text_3 }}
        </span>
      </div>
    </div>
    <div :style="scroll">
      <div class="row" v-for="i in parseInt(numRows)" :key="i" :ref="i">
        <div class="col-md-8">
          <fg-input
            class="sensor"
            type="text"
            v-model="model.refSensor[i - 1]"
            name="refSensor"
            :placeholder="dictionary.placeholder_2"
            :disabled="!model.sensor"
            maxlength="8"
            @keypress="validateCode"
          ></fg-input>
        </div>
        <div
          class="col-md-1 py-2"
          style="display: flex; justify-content: center"
          v-if="model.sensor"
        >
          <div
            class="col-md-md-1 d-flex justify-content-center"
            style="margin-top: -12px"
          >
            <button
              type="button"
              @click="deleteRow(i)"
              style="border: none; background: white"
              v-if="numRows > 1"
            >
              <em
                class="fa fa-trash"
                style="color: red; font-size: 20px"
                v-tooltip.top-center="dictionary.btn_1"
              ></em>
            </button>
            <button
              type="button"
              @click="addRow"
              style="border: none; background: white"
            >
              <em
                class="fa fa-plus"
                style="cursor: pointer; color: #82c341; font-size: 20px"
                v-tooltip.top-center="dictionary.btn_2"
              ></em>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-md" style="display: contents">
        <el-radio-group
          @change="changeRefSensroTime"
          v-model="model.refSensorTime"
          class="ml-4 custom-radio-button"
        >
          <el-radio :label="false" style="white-space: break-spaces">{{
            dictionary.label_4
          }}</el-radio>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinTranslate from 'src/util/mixinTranslate';
import { RadioGroup, Radio, RadioButton } from 'element-ui';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
  },

  data() {
    return {
      model: {
        station: false,
        sensor: false,
        refStation: null,
        refSensor: [],
        refStationTime: false,
        refSensorTime: false,
      },
      globalDictionary: {},
      dictionary: {
        text_1: null,
        text_2: null,
        text_3: null,
        text_4: null,
        label_1: null,
        label_2: null,
        label_3: null,
        label_4: null,
        placeholder_1: null,
        placeholder_2: null,
        btn_1: null,
        btn_2: null,
      },
      numRows: 1,
      msg: null,
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinTranslate],

  computed: {
    scroll() {
      let style = '';
      if (this.numRows > 3)
        style = 'overflow-y: scroll; height: 200px; overflow-x: hidden;';
      return style;
    },
  },

  methods: {
    En() {
      this.dictionary = this.translateEn()['secondStep'];
      this.globalDictionary = this.translateEn();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
    },
    Es() {
      this.dictionary = this.translateEs()['secondStep'];
      this.globalDictionary = this.translateEs();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
    },
    addRow() {
      this.numRows = this.numRows * 1 + 1;
    },
    deleteRow(i) {
      this.model.refSensor.splice(i - 1, 1);
      this.numRows = this.numRows * 1 - 1;
      if (this.numRows == 0) this.numRows = 1;
    },
    changeRadioStation(e) {
      this.model.refStationTime = e;
    },
    changeRefStationTime(e) {
      this.model.station = e;
    },
    changeRadioSensor(e) {
      this.model.refSensorTime = e;
      if (!e) {
        this.numRows = 1;
        this.model.refSensor = [];
      }
    },
    changeRefSensroTime(e) {
      this.model.sensor = e;
      if (!e) {
        this.numRows = 1;
        this.model.refSensor = [];
      }
    },
    customError(ref) {
      document.getElementById(ref).classList.add('custom-has-error');
      setTimeout(() => {
        document.getElementById(ref).classList.remove('custom-has-error');
      }, 4000);
    },
    validateCode(e) {
      if (
        (e.keyCode >= 48 && e.keyCode <= 57) ||
        (e.keyCode >= 65 && e.keyCode <= 90) ||
        (e.keyCode >= 97 && e.keyCode <= 122)
      ) {
        // e.preventDefault();
      } else {
        e.preventDefault();
      }
    },
    validated() {
      return this.$validator.validateAll().then((res) => {
        let band = true;
        if (
          (this.model.refStation * 1 == 0 || this.model.refStation == null) &&
          this.model.station
        ) {
          this.customError('station');
          band = false;
        }
        if (this.model.station && this.model.refStation.length != 8) {
          this.customError('station');
          band = false;
        }

        let obj = document.getElementsByClassName('sensor');
        Object.keys(obj).forEach((i) => {
          if (obj[i].__vue__.value === undefined && this.model.sensor) {
            band = false;
            obj[i].children[0].classList.add('custom-has-error');
            setTimeout(() => {
              obj[i].children[0].classList.remove('custom-has-error');
            }, 4000);
          }
        });
        if (this.model.sensor && this.model.refSensor.length != 0) {
          this.model.refSensor.forEach((sensor, i) => {
            if (sensor.length != 8) {
              band = false;
              obj[i].children[0].classList.add('custom-has-error');
              setTimeout(() => {
                obj[i].children[0].classList.remove('custom-has-error');
              }, 4000);
            } else {
              let duplicados = [];
              let len = JSON.parse(
                sessionStorage.getItem('globalDictionary')
              ).language;
              const tempArray = [...this.model.refSensor].sort();
              for (let i = 0; i < tempArray.length; i++) {
                if (tempArray[i + 1] === tempArray[i]) {
                  duplicados.push(tempArray[i]);
                }
              }
              duplicados = [...new Set(duplicados)];
              if (duplicados.length > 0) {
                for (const key in duplicados) {
                  if (len == 'Es') {
                    this.msg =
                      'El sensor ' +
                      duplicados[key] +
                      ' se encunetra duplicado.';
                  } else {
                    this.msg = 'Sensor ' + duplicados[key] + ' is duplicated.';
                  }
                  SweetAlert.warning(this.msg);
                }
                band = false;
              }
            }
          });
        }
        if (band) {
          this.$emit('on-validated', res, this.model);
        }
        return band;
      });
    },
  },
  created() {
    if (sessionStorage.getItem('globalDictionary')) {
      this.dictionary = JSON.parse(
        sessionStorage.getItem('globalDictionary')
      ).secondStep;
    } else {
      this.Es();
    }
    this.showHideLoading();
  },
};
</script>
<style>
.el-radio__input.is-checked + .el-radio__label {
  color: #a4a69c;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #a4a69c;
  background: #a4a69c;
}
.el-radio__inner {
  border: 1px solid #a4a69c;
  border-radius: 100%;
  width: 18px;
  height: 18px;
}
.el-radio__inner:hover {
  border-color: #a4a69c;
}
</style>
